/**
 * Returns the `window` object if it exists in the current
 * environment, otherwise `undefined`
 */
export const getWindow = (): Window | undefined =>
  typeof window === 'object' ? window : undefined;
